import { camelizeKeys } from 'humps';
import { z } from 'zod';
import { post, validateScheme } from '@namespace/helpers';

const AddBonusParticipantResponseSchema = z.object({
  status: z.string(),
  data: z.object({})
});

type AddBonusParticipantResponse = z.infer<
  typeof AddBonusParticipantResponseSchema
>;

export const addBonusParticipant = (options: {
  bonusTemplateId: string;
  bonusSource: string;
}) =>
  post<AddBonusParticipantResponse>(
    `/service/bff/v1/bonuses/bonus-instance/create`,
    {
      bonus_template_id: Number(options.bonusTemplateId),
      bonus_source: options.bonusSource
    }
  ).then((response) => {
    validateScheme(AddBonusParticipantResponseSchema, response, {
      name: 'addBonusParticipant'
    });

    return camelizeKeys(response);
  });
